var exports = {
  "kL": "x127c5a35--e6b4e0--container",
  "uW": "x127c5a35--e6b4e0--filters",
  "sM": "x127c5a35--e6b4e0--filters-header",
  "wx": "x127c5a35--e6b4e0--header",
  "nM": "x127c5a35--e6b4e0--row",
  "HX": "x127c5a35--e6b4e0--favorites-type",
  "Lu": "x127c5a35--e6b4e0--favorites-type-item",
  "Rf": "x127c5a35--e6b4e0--favorites-type-item--active",
};

module.exports = exports;
